import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule} from '@angular/material/button';

import { PrivacySnackBar } from './privacy-snack-bar.component';

@NgModule({
  declarations: [
    PrivacySnackBar
  ],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports: [
    PrivacySnackBar
  ]
})
export class PrivacySnackBarModule { }
